export function CiclosJSON() {
  const ciclosArray = [
    {
      nombre: "Teens",
      peliculas: [
        {
          tmdb_ID: "2640",
          name: "las-heathers",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "26280",
          name: "j'ai-tué-ma-mère",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "50272",
          name: "somos-lo-que-hay",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "37686",
          name: "super-8",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "42148",
          name: "pixote:-a-lei-do-mais-fraco",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "533444",
          name: "las-olas",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "23655",
          name: "mundo-rave",
          propuestaPor: "Luis"
        },
        {
          tmdb_ID: "474444",
          name: "les-garçons-sauvages",
          propuestaPor: "Luis"
        },
      ],
    },
    {
      nombre: "Cyberpunk",
      peliculas: [
        {
          nombre: "The Edge of tomorrow",
          tmdb_ID: "137113",
        },
        {
          nombre: "Turbo Kid",
          tmdb_ID: "310135",
        },
        {
          nombre: "Sleep Dealer",
          tmdb_ID: "20764",
        },
      ],
    },
    {
      nombre: "Mexicanas",
      peliculas: [
        {
          nombre: "Nuestro Tiempo",
          tmdb_ID: "389218",
        },
        {
          nombre: "Like Water for Chocolate",
          tmdb_ID: "18183",
        },
        {
          nombre: "El Lugar sin limites",
          tmdb_ID: "77360",
        },
        {
          nombre: "Macario",
          tmdb_ID: "122019",
        },
        {
          nombre: "Simon del Desierto",
          tmdb_ID: "36265",
        },
        {
          nombre: "Enamorada",
          tmdb_ID: "115301",
        },
        
      ],
    }
  ];

  return ciclosArray;
}
